// /v1/me 系の React Query フック(設計書 §3.4.2)

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from './client';

export interface PerformerProfile {
  ulid: string;
  email: string;
  display_name: string;
  plan: 'free' | 'pro';
  status: 'pending' | 'active' | 'disabled';
  google_linked: boolean;
  total_streaming_seconds: number;
  total_session_count: number;
  created_at: string;
  last_login_at: string | null;
}

export const meQueryKey = ['me'] as const;

export function useMe() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: () => apiRequest<PerformerProfile>('/me'),
  });
}

interface UpdateMeInput {
  display_name?: string;
}

interface UpdateMeResponse {
  ulid: string;
  display_name: string;
}

export function useUpdateMe() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateMeInput) =>
      apiRequest<UpdateMeResponse>('/me', { method: 'PATCH', body: input }),
    onSuccess: (data) => {
      qc.setQueryData<PerformerProfile | undefined>(meQueryKey, (prev) =>
        prev ? { ...prev, display_name: data.display_name } : prev,
      );
    },
  });
}

interface UpdatePasswordInput {
  current_password: string;
  new_password: string;
}

export function useUpdatePassword() {
  return useMutation({
    mutationFn: (input: UpdatePasswordInput) =>
      apiRequest<void>('/me/password', { method: 'PATCH', body: input }),
  });
}
